export type InitialFormValuesProps = {
  jbox_type?: number;
  chronicle_type?: string;
};

export type CustomRadioInputProps = {
  formData: InitialFormValuesProps;
  disabled: boolean;
};

export enum JboxTypeEnum {
  Jbox_1 = 1,
  Jbox_2 = 2,
}

export type ChoicesType = { id: string; name: string }[];

export enum ChronicleTypeEnum {
  Performance = "Performance",
  MSI = "MSI",
}

export type GenerationTabFormProps = {
  initialFormValues: InitialFormValuesProps;
  resetForm: () => void;
};
